import { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Alert,
  Autocomplete,
  Avatar,
  Chip,
  FormHelperText,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MaterialSelect";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import { BASE_URL } from "../../../Utils/Baseurl";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CloseIcon from "@mui/icons-material/Close";
import MaterialDatePicker from "../../../../components/MaterialDatePicker";

const AddProject = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editId = location?.state?.projectId || 0;
  const [projectType, setProjectType] = useState([]);
  const [status, setStaus] = useState([]);
  const [priority, setPriority] = useState([]);

  const [projectData, setProjectData] = useState({
    projectLogo: null,
    projectName: "",
    projectCode: "",
    projectManager: "",
    techLeads: [],
    startDate: "",
    endDate: "",
    milestones: "",
    budget: "",
    teamMembers: [],
    projectTask: {},
    projectStatus: {},
    projectPriority: {},
    description: "",
    projectNameStatus: "unchecked",
    projectCodeStatus: "unchecked",
    projectManagerStatus: "unchecked",
    techLeadsStatus: "unchecked",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
    milestonesStatus: "unchecked",
    budgetStatus: "unchecked",
    teamMembersStatus: "unchecked",
    descriptionStatus: "unchecked",
    projectTaskStatus: "unchecked",
    projectStatusStatus: "unchecked",
    projectPriorityStatus: "unchecked",
  });

  const [teamMembersData, setTeamMembersData] = useState([]);
  const [techLeadsData, setTechLeadsData] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  let path = window.location.pathname;


  useEffect(() => {
    fetchTeamMembers();
    fetchProjectStatus();
    fetchProjectType();
    fetchProjectPriority();
    fetchTechLeads();
  }, []);

  /**
   * Fetches a project from the API based on the editId.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the projectData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchProject = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/project/${editId}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data.data;
      setProjectData({
        projectLogo: data.logo_image,
        projectName: data.project_name,
        projectCode: data.project_code,
        projectManager: { value: data.manager, label: data.manager_name },
        techLeads: data.tech_leads || [],
        startDate: data.start_date,
        endDate: data.end_date,
        milestones: data.milestone,
        budget: data.budget,
        teamMembers: data.resource_allocation,
        description: data.description,
        projectTask: { value: data?.project_type, label: data?.project_type },
        projectStatus: {
          value: data?.status,
          label: data?.status,
        },
        projectPriority: {
          value: data?.priority_level,
          label: data?.priority_level,
        },
        projectNameStatus: "success",
        projectCodeStatus: "success",
        projectManagerStatus: "success",
        techLeadsStatus: data.tech_leads && data.tech_leads.length > 0 ? "success" : "unchecked",
        startDateStatus: "success",
        endDateStatus: "success",
        milestonesStatus: "success",
        budgetStatus: "success",
        teamMembersStatus: "success",
        descriptionStatus: "success",
        projectTaskStatus: "success",
      });
    } catch (error) {
      console.error("Error fetching project:", error);
    }
  };

  useEffect(() => {
    if (editId !== 0) {
      fetchProject();
    }
  }, []);

  /**
   * Fetches team members from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, transforms the data to match the expected format and sets the teamMembersData state with the transformed data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchTeamMembers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        id: item.id,
        employee_name: item?.employee_name,
        team: item.team?.team_name,
      }));
      setTeamMembersData(transformedData);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };

  const fetchTechLeads = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/tech-leads/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        id: item.id,
        employee_name: item?.employee_name,
        team: item.team?.team_name,
      }))
      setTechLeadsData(transformedData);
    } catch (error) {
      console.error("Error fetching tech leads:", error);
    }
  };

  const fetchProjectType = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/ProjectType/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const projectType = data.data.map((item) => ({
        value: item.id,
        label: item?.projecttype,
      }));
      setProjectType(projectType);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };


  const fetchProjectStatus = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/Status/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const status = data.data.map((item) => ({
        value: item.id,
        label: item.status,
      }));
      setStaus(status);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };


  const fetchProjectPriority = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/priority/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const status = data.data.map((item) => ({
        value: item.priority,
        label: item.priority,
      }));
      setPriority(status);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };

  const handleProjectChange = (e, selectEvent) => {
    setProjectData((prevData) => {
      let updatedData = { ...prevData };

      if (e?.target === undefined) {
        if (selectEvent.name === "projectTask") {
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(e?.label) === true) {
            updatedData[selectEvent.name + "Status"] =
              e?.label === undefined ? "unchecked" : "success";
          } else {
            updatedData[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
          }
        }
        if (selectEvent.name === "projectStatus") {
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(e?.label) === true) {
            updatedData[selectEvent.name + "Status"] =
              e?.label === undefined ? "unchecked" : "success";
          } else {
            updatedData[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
          }
        }
        if (selectEvent.name === "projectPriority") {
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(e?.label) === true) {
            updatedData[selectEvent.name + "Status"] =
              e?.label === undefined ? "unchecked" : "success";
          } else {
            updatedData[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
          }
        }
        updatedData[selectEvent.name] = e;
      } else {
        // Validation logic for each field
        const { name, value } = e.target;
        let statusField = `${name}Status`;
        switch (name) {
          case "projectName":
            const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
            if (value.trim() === "") {
              updatedData.projectNameStatus = "error";
            } else if (value.length < 0) {
              updatedData.projectNameStatus = "error";
            } else if (!alphanumericRegex.test(value)) {
              updatedData.projectNameStatus = "error";
            } else {
              updatedData.projectNameStatus = "success";
            }
            updatedData.projectName = value;
            break;

          case "projectCode":
            const codeRegex = /^[A-Z0-9-]{3,10}$/;
            if (value.trim() === "") {
              updatedData.projectCodeStatus = "error";
            } else if (!codeRegex.test(value)) {
              updatedData.projectCodeStatus = "error";
            } else {
              updatedData.projectCodeStatus = "success";
            }
            updatedData.projectCode = value;
            break;

          case "startDate":
            const startValid = /^\d{4}-\d{2}-\d{2}$/.test(value);
            if (!startValid) {
              updatedData[statusField] = "error";
            } else {
              const startDate = new Date(value);
              const day = startDate.getDay(); // 0 = Sunday, 6 = Saturday

              if (day === 0 || day === 6) {
                // Weekend selected
                updatedData[statusField] = "error";
              } else {
                updatedData[statusField] = "success";

                // If endDate exists, ensure endDate is after or equal to startDate
                if (updatedData.endDate) {
                  const endDate = new Date(updatedData.endDate);
                  updatedData.endDateStatus =
                    endDate >= startDate ? "success" : "error";
                }
              }

              updatedData[name] = value;
            }
            break;


          case "endDate":
            const endValid = /^\d{4}-\d{2}-\d{2}$/.test(value);
            if (!endValid) {
              updatedData[statusField] = "error";
            } else {
              const endDate = new Date(value);
              const day = endDate.getDay(); // 0 = Sunday, 6 = Saturday

              if (day === 0 || day === 6) {
                // Weekend selected
                updatedData[statusField] = "error";
              } else {
                const startDate = new Date(prevData.startDate);

                // Only check if endDate is after or equal to startDate (if startDate exists)
                if (prevData.startDate && endDate < startDate) {
                  updatedData[statusField] = "error";
                } else {
                  updatedData[statusField] = "success";
                }
              }

              updatedData[name] = value;
            }
            break;


          case "milestones":
            if (value.trim() === "") {
              updatedData.milestonesStatus = "error";
            } else if (value.length < 0) {
              updatedData.milestonesStatus = "error";
            } else {
              updatedData.milestonesStatus = "success";
            }
            updatedData.milestones = value;
            break;

          case "budget":
            const budgetValue = parseFloat(value);
            if (value === "" || isNaN(budgetValue)) {
              updatedData.budgetStatus = "error";
            } else if (budgetValue <= 0) {
              updatedData.budgetStatus = "error";
            } else {
              updatedData.budgetStatus = "success";
            }
            updatedData.budget = value;
            break;

          case "description":
            const descRegex = /^[A-Za-z0-9\s\.\:\'\"\/@#%\(\)\[\]\{\},]+$/;
            if (value.trim() === "") {
              updatedData.descriptionStatus = "error";
            } else if (!descRegex.test(value)) {
              updatedData.descriptionStatus = "error";
            } else if (value.length < 10) {
              updatedData.descriptionStatus = "error";
            } else {
              updatedData.descriptionStatus = "success";
            }
            updatedData.description = value;
            break;

          default:
            break;
        }
      }

      return updatedData;
    });
  };


  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    setProjectData((prevData) => ({
      ...prevData,
      startDate: formattedDate,
      startDateStatus: "success",
    }));
  };


  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    setProjectData((prevData) => ({
      ...prevData,
      endDate: formattedDate,
      endDateStatus: "success",
    }));
  };


  const handleManagerChange = (selectedOption) => {
    setProjectData((prevData) => ({
      ...prevData,
      projectManager: selectedOption,
      projectManagerStatus: selectedOption ? "success" : "error",
    }));
  };

  const handleTechLeadChange = (event, newValue) => {
    setProjectData({
      ...projectData,
      techLeads: newValue,
      techLeadsStatus: newValue.length > 0 ? "success" : "error",
    });
  };

  const handleMemberChange = (event, newValue) => {
    setProjectData({
      ...projectData,
      teamMembers: newValue,
      teamMembersStatus: newValue.length > 0 ? "success" : "error",
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        alert("Image size must be less than 2MB.");
        setProjectData((prev) => ({
          ...prev,
          projectLogoStatus: "error",
        }));
        return;
      }

      setProjectData((prev) => ({
        ...prev,
        projectLogo: file,
        projectLogoStatus: "success",
      }));
    }
  };

  const handleAvatarClick = () => {
    document.getElementById("imageUpload").click();
  };

  const handleImageDelete = () => {
    setProjectData((prev) => ({
      ...prev,
      projectLogo: null,
    }));
  };

  /**
   * Handles project form submission.
   * Creates a new project if `editId` is 0, otherwise updates the existing project.
   * Collects form data, constructs a FormData object, and sends a POST/PUT request to the API.
   * If the request is successful, logs a success message, sets a success snackbar, and navigates to /project.
   * If the request fails, logs an error message, sets an error snackbar, and remains on the current page.
   * @param {number} editId - The ID of the project to edit, or 0 to create a new project.
   */
  const handleProjectSubmit = async () => {
    const data = new FormData();

    const user_id = sessionStorage.getItem("currentUser");

    const {
      projectLogo,
      projectName,
      projectCode,
      projectManager,
      techLeads,
      startDate,
      endDate,
      budget,
      teamMembers,
      description,
      projectTask,
      projectStatus,
      projectPriority,
    } = projectData;
    {
      projectLogo?.name && data.append("logo_image", projectLogo);
    }
    data.append("project_name", projectName);
    data.append("project_code", projectCode);
    data.append("manager", projectManager?.value);
    data.append("start_date", startDate);
    data.append("end_date", endDate);
    data.append("budget", budget);
    data.append("resource_allocation", JSON.stringify(Array.isArray(teamMembers) ? teamMembers : []));
    data.append("tech_leads", JSON.stringify((Array.isArray(techLeads) ? techLeads : []).map((lead) => Number(lead?.id || lead))));
    data.append("description", description);
    data.append("project_type", projectTask?.label);
    data.append("priority_level", projectPriority?.label);
    data.append("user_id", user_id);
    {
      editId !== 0 && data.append("status", projectStatus?.label);
    }

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token not found. Please log in.");
      }

      let response;

      if (editId === 0) {
        response = await axios.post(`${BASE_URL}api/project/`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Project created successfully:", response.data);
        if (response?.data?.status) {
          setSnackbar({
            open: true,
            message: response?.data?.message,
            severity: "success",
          });
          navigate("/project-list");
        } else {
          setSnackbar({
            open: true,
            message: response?.data?.message,
            severity: "error",
          });
        }
      } else {
        response = await axios.put(`${BASE_URL}api/project/${editId}/`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Project updated successfully:", response.data);

        if (response?.data?.status) {
          setSnackbar({
            open: true,
            message: response?.data?.message,
            severity: "success",
          });

          if (path === "/project-list/edit-project") {
            navigate("/portfolio")
          } else {
            navigate("/project-list");
          }

        } else {
          setSnackbar({
            open: true,
            message: response?.data?.message,
            severity: "error",
          });
        }
      }
    } catch (error) {
      console.error(
        "Error processing project:",
        error.response?.data || error.message
      );
      console.log(`Failed to ${editId === 0 ? "create" : "update"} project`);
      setSnackbar({
        open: true,
        message: `Failed to ${editId === 0 ? "create" : "update"} project`,
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const checkAllFields = () => {
    return (
      projectData.projectNameStatus === "success" &&
      projectData.projectCodeStatus === "success" &&
      projectData.projectManagerStatus === "success" &&
      projectData.startDateStatus === "success" &&
      projectData.endDateStatus === "success" &&
      projectData.budgetStatus === "success" &&
      projectData.teamMembersStatus === "success" &&
      projectData.descriptionStatus === "success" &&
      projectData.projectTaskStatus === "success"
      // projectData.projectStatusStatus === "success"
    );
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium" color="dark">
            Add Project
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can add the project here.
          </MaterialTypography>
        </Stack>
      </Stack>

      <Grid container spacing={2} p={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Project Logo<span style={{ color: "red" }}>*</span>
            </MaterialTypography>

            <div
              style={{ position: "relative", width: "100px", height: "100px" }}
            >
              <input
                id="imageUpload"
                type="file"
                accept="image/jpeg, image/png"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <Avatar
                alt="Project Logo"
                src={
                  projectData.projectLogo instanceof File
                    ? URL.createObjectURL(projectData.projectLogo)
                    : projectData.projectLogo
                      ? BASE_URL + projectData.projectLogo
                      : ""
                }
                onClick={handleAvatarClick}
                sx={{
                  width: "100px",
                  height: "100px",
                  cursor: "pointer",
                }}
              >
                {!projectData.projectLogo && (
                  <AddAPhotoIcon sx={{ width: "60px", height: "60px" }} />
                )}
              </Avatar>

              {projectData.projectLogo && (
                <IconButton
                  size="small"
                  onClick={handleImageDelete}
                  sx={{
                    position: "absolute",
                    top: 3,
                    right: 3,
                    backgroundColor: "white",
                    boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                    zIndex: 1,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </div>
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Project Name<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="projectName"
              placeholder="Enter Project Name"
              value={projectData.projectName}
              onChange={handleProjectChange}
              error={projectData.projectNameStatus === "error"}
              success={projectData.projectNameStatus === "success"}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Project Code<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="projectCode"
              placeholder="Enter Project Code"
              value={projectData.projectCode}
              onChange={handleProjectChange}
              error={projectData.projectCodeStatus === "error"}
              success={projectData.projectCodeStatus === "success"}
            />
            <FormHelperText>
              {
                projectData.projectCodeStatus === "error" && (
                  <MaterialTypography
                    variant="caption"
                    fontWeight="medium"
                    color="text"
                  >
                    Code must start with 3 uppercase letters followed by digits (e.g., KIS1234)
                  </MaterialTypography>
                )
              }
            </FormHelperText>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Project Manager<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="manager"
              placeholder="Select Manager"
              value={projectData.projectManager}
              onChange={handleManagerChange}
              options={teamMembersData.map((member) => ({
                label: member.employee_name,
                value: member.id,
              }))}
              error={projectData.projectManagerStatus === "error"}
              success={projectData.projectManagerStatus === "success"}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Tech Leads<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              id="tech-leads-outlined"
              options={techLeadsData || []}
              getOptionLabel={(option) =>
                `${option?.employee_name || ""} (${option?.team || "No Team"})`
              }
              value={Array.isArray(projectData.techLeads) ? projectData.techLeads : []}
              onChange={handleTechLeadChange}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (Array.isArray(selected) ? selected : []).map((option, index) => (
                  <Chip
                    key={option?.id || index}
                    label={`${option?.employee_name || ""}`}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Add tech leads" />
              )}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Start Date<span style={{ color: "red" }}>*</span>
            </MaterialTypography>

            <MaterialDatePicker
              name="startDate"
              type="date"
              value={projectData.startDate}
              onChange={handleStartDateChange}
              error={projectData.startDateStatus === "error"}
              success={projectData.startDateStatus === "success"}
              helperText={
                projectData.startDateStatus === "error"
                  ? "Weekends (Saturday & Sunday) are not allowed"
                  : ""
              }
              options={{
                disable: [
                  function (date) {
                    // 0 = Sunday, 6 = Saturday
                    return (date.getDay() === 0 || date.getDay() === 6);
                  },
                ],
              }}
            />
            <FormHelperText style={{ color: "red", fontSize: '10px' }}>
              {projectData.startDateStatus === "error" ? "Weekends (Saturday & Sunday) are not allowed" : ""}</FormHelperText>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              End Date<span style={{ color: "red" }}>*</span>
            </MaterialTypography>

            <MaterialDatePicker
              name="endDate"
              type="date"
              value={projectData.endDate}
              onChange={handleEndDateChange}
              error={projectData.endDateStatus === "error"}
              success={projectData.endDateStatus === "success"}
              helperText={
                projectData.endDateStatus === "error"
                  ? "Weekends (Saturday & Sunday) are not allowed"
                  : ""
              }
              options={{
                disable: [
                  function (date) {
                    // 0 = Sunday, 6 = Saturday
                    return (date.getDay() === 0 || date.getDay() === 6);
                  },
                ],
              }}
            />
            <FormHelperText style={{ color: "red", fontSize: '10px' }}>{projectData.endDateStatus === "error" ? "Weekends (Saturday & Sunday) are not allowed" : ""}</FormHelperText>
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Budget<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="budget"
              placeholder="Enter Budget"
              value={projectData.budget}
              onChange={handleProjectChange}
              error={projectData.budgetStatus === "error"}
              success={projectData.budgetStatus === "success"}
            />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Team Members<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={teamMembersData || []}
              getOptionLabel={(option) =>
                `${option?.employee_name || ""} (${option?.team || "No Team"})`
              }
              value={Array.isArray(projectData.teamMembers) ? projectData.teamMembers : []}
              onChange={handleMemberChange}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (Array.isArray(selected) ? selected : []).map((option, index) => (
                  <Chip
                    key={option?.id || index}
                    label={`${option?.employee_name || ""} (${option?.team || "No Team"
                      })`}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Add team developers" />
              )}
            />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography variant="caption" color="text">
              Project Type <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="projectTask"
              customStyles={{ optionPadding: 20 }}
              value={projectData?.projectTask}
              onChange={handleProjectChange}
              options={projectType}
              error={projectData.projectTaskStatus === "error"}
              success={projectData.projectTaskStatus === "success"}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography variant="caption" color="text">
              Project Priority
            </MaterialTypography>
            <MaterialSelect
              name="projectPriority"
              value={projectData?.projectPriority}
              onChange={handleProjectChange}
              options={priority}
              error={projectData?.projectStatusStatus === "error"}
              success={projectData?.projectStatusStatus === "success"}
            />
          </Stack>
        </Grid>
        {editId !== 0 && (
          <Grid size={{ xs: 12, md: 4 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography variant="caption" color="text">
                Project Status
              </MaterialTypography>
              <MaterialSelect
                name="projectStatus"
                value={projectData?.projectStatus}
                onChange={handleProjectChange}
                options={status}
                error={projectData?.projectStatusStatus === "error"}
                success={projectData?.projectStatusStatus === "success"}
              />
            </Stack>
          </Grid>
        )}

        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              fontWeight="medium"
              color="text"
            >
              Description<span style={{ color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="description"
              placeholder="Enter description"
              multiline
              rows={4}
              value={projectData.description}
              onChange={handleProjectChange}
              error={projectData.descriptionStatus === "error"}
              success={projectData.descriptionStatus === "success"}
            />
          </Stack>
        </Grid>
      </Grid>
      <MaterialBox display="flex" justifyContent={{ md: "flex-end", mt: 3 }}>
        <MaterialButton
          variant="gradient"
          color="dark"
          style={{ maxWidth: "100px", minWidth: "100px" }}
          onClick={handleProjectSubmit}
          disabled={!checkAllFields()}
        >
          submit
        </MaterialButton>
      </MaterialBox>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

export default AddProject;
